import { Association } from '@prisma/client';

import { routes } from '@/shared/routes';

import { initButtons } from '@/front/action';
import { modelId } from '@/front/actions/utils';
import { initEditables } from '@/front/editable';
import { DELETE, POST } from '@/front/fetch';
import { getLookupPicker } from '@/front/lookupPicker';
import { alertModal } from '@/front/modal';
import { initTooltips } from '@/front/tooltip';

export const insertLinkedIndividualRow = (rowHtml: string) => {
  const body = document.getElementById('linkedIndividuals');

  body?.insertAdjacentHTML('beforeend', rowHtml);

  const row = body?.lastElementChild;

  if (row) {
    initButtons(row);
    initEditables(row);
    initTooltips(row);
    row.scrollIntoView({ block: 'nearest' });
  }

  getLookupPicker('individualPicker')?.refresh();
};

export const createIndividualAssociation = async () => {
  const picker = getLookupPicker('individualPicker');

  if (picker) {
    const organisationId = modelId();
    const individualId = picker?.value as string | undefined;

    if (organisationId && individualId) {
      const association: Partial<Association> = {
        organisationId,
        individualId,
      };

      const res = await POST(`${routes.associations.create()}?view=Organisation`, association);

      if (res.ok) {
        insertLinkedIndividualRow(await res.text());
        picker.value = '';
      } else {
        const errorBody = await res.json().catch(() => null);
        const message = errorBody?.message ?? 'Failed to link individual.';
        alertModal(message);
      }
    }
  }
};

export const createOrganisationAssociation = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const picker = getLookupPicker('organisationPicker');

  if (picker) {
    const individualId = modelId();
    const organisationId = picker.value as string | undefined;

    if (individualId && organisationId) {
      const association: Partial<Association> = {
        individualId,
        organisationId,
      };

      const res = await POST(`${routes.associations.create()}?view=Individual`, association);

      if (res.ok) {
        button.closest('tr')?.insertAdjacentHTML('beforebegin', await res.text());
        picker.value = '';
      } else {
        const errorBody = await res.json().catch(() => null);
        const message = errorBody?.message ?? 'Failed to link organisation.';
        alertModal(message);
      }
    }
  }
};

export const deleteAssociation = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const id = button.dataset.value;

  if (id) {
    const res = await DELETE(routes.associations.edit({ id }));

    if (res.ok) {
      button.closest('tr')?.remove();

      getLookupPicker('organisationPicker')?.refresh();
      getLookupPicker('individualPicker')?.refresh();
    }
  }
};

export const setPrimaryAssociation = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const id = button.dataset.value;

  if (id) {
    const res = await POST(routes.associations.primary({ id }));

    if (res.ok) {
      document.querySelectorAll('.primary-association i').forEach((icon) => {
        icon.className = 'fa-regular fa-circle text-muted';
      });

      const icon = button.querySelector('i');
      if (icon) icon.className = 'fa-solid fa-circle-dot text-primary';
    }
  }
};
